
import { useRef, useEffect } from "react"
import { useEditor } from "../EditorContext"


function LabelForm({label, formStructure, parentElementType}) {

  const { updateLabel, setEditingElement } = useEditor()

  const inputRef = useRef(null)
  useEffect(() => {
    inputRef.current.focus()
  }, [])


  return (
    <div className='group-editor mt-0 mb-4'>
      <div className='editor-header'>
        <h4 className='editor-header'>
          <button 
            className='btn editor-button me-4'
            onClick={(e) => setEditingElement(undefined)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-check-square" viewBox="0 0 16 16">
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
              <path d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
            </svg>
          </button>
          { parentElementType === 'group' ? <>Редактирование текстового блока: </> : <>Редактирование лейбла: </> }
         </h4>
      </div>
      <div className='editor-content'>
        <div className="form">
          <div className="row mb-3">
            <label className="col-sm-2 col-form-label">Текст</label>
            <div className="col-sm-10">
              <input
                id="text"
                type="text"
                className="form-control"
                value={label.text}
                onChange={(e) => updateLabel(formStructure, label.id, e.target)}
                placeholder="комментарий"
                ref={inputRef}
              />
            </div>  
          </div>
          { parentElementType === 'layout' ? 
            <>
              <div className="row mb-3">  
                <label className="col-sm-2 col-form-label mt-1">Заголовок таблицы</label>
                <div className="col-sm-10">
                  <input
                    id="OPTIONS__labelRenderer"
                    value="table_head"
                    type="checkbox"
                    className="form-check-input lk-checkbox mt-2"
                    checked={label.options.labelRenderer === 'table_head'}
                    //  нужен рефакторинг аргументов для вызова функции
                    onChange={(e) => updateLabel(formStructure, label.id, e.target)}
                  />
                </div>
              </div>
            </>
              :
            <></>  
          }
        </div>
      </div>
    </div>
  )
}

export default LabelForm